<template>
  <div class="mb5" id="navBarContainer">
    <b-navbar variant="light" fixed="top" toggleable toggle-breakpoint="lg">
      <b-navbar-brand @click="navBarCollapse=false">
        <router-link to="/">
          <img src="/main/menu_logo.png" class="d-inline-block align-top" alt="">
          AK Wilno
        </router-link>
      </b-navbar-brand>
      <b-nav-toggle target="">
          <span @click="navBarCollapse=!navBarCollapse" class="navbar-toggler-icon"></span>
      </b-nav-toggle>
      <b-collapse is-nav id="navBar" :visible="navBarCollapse">
        <b-nav is-nav-bar>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/" exact>Start</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/aktualnosci">Aktualności</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/o_autorze">O Autorze</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/kolekcja">Kolekcja Janusza Bohdanowicza</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/historia">Historia AK na Wileńszczyźnie</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/srodowiska">Środowiska kombatanckie</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/sponsorzy">Sponsorzy</router-link>
          </b-nav-item>
          <b-nav-item @click="navBarCollapse=false">
            <router-link active-class="activeNav" to="/kontakt">Kontakt</router-link>
          </b-nav-item>
        </b-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'navBar',
  data: function(){
    return {
      navBarCollapse: false
    }
  }
}
</script>

<style scoped>
  a{
    color: grey;
  }

  img{
    width: 35px
  }

  .activeNav{
    color: #4286f4;
  }

  #navBarContainer{
    margin-bottom: 4em;
  }

  @media screen and (min-width: 992px){
    #navBarContainer{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/navBar.vue